import { AppLogo } from './AppLogo';

export const LittlebirdMarkIcon = ({ className }: { className?: string }) => (
  <AppLogo size="100%" className={className} decorative />
);
